// src/utils/constants.js

import {
    GlobeAltIcon,
    UserCircleIcon,
    UsersIcon
} from "@heroicons/react/24/outline";

// export const API_URL = "http://localhost:3000";
// export const API_URL = "https://192.168.7.19:3000";
export const API_URL = "https://api.seanag-recommendations.org:8080"
// foundations ip address
// export const API_URL = "http://192.168.7.20:3000"
// vsundy ip address
// export const API_URL = "https://10.0.0.104:3000"
export const CLOUD_CDN_BASE_URL = "https://images.triedandtrusted.ai"
export const INTRO_TEXT =
    "Share recommendations with your Trust Circle. Let's add one now...";
export const TYPEWRITER_SPEED = 40;

// Helper function to construct profile image URLs
export const getProfileImageUrl = (profileImageGcsPath) => {
    if (!profileImageGcsPath) return null;
    
    // If it's already a full URL (starts with http), return it as is
    if (profileImageGcsPath.startsWith('http')) {
        return profileImageGcsPath;
    }
    
    // Otherwise, construct URL with CDN base
    return `${CLOUD_CDN_BASE_URL}/${profileImageGcsPath}`;
};

export const PUBLISH_OPTIONS = [
    {
        value: "Full Trust Circle",
        label: "Entire Trust Circle",
        icon: UsersIcon,
    },
    {
        value: "Specific Trust Circles",
        label: "Specific Trust Circles",
        icon: UserCircleIcon, // Re-using UsersIcon, UserCircleIcon was not imported previously by name
    },
    { value: "Public", label: "Public", icon: GlobeAltIcon },
];

export const CSV_HEADERS_SCHEMA = `business_name, category_id, created_at, recommended_by, service_id, email, phone_number, num_likes, date_of_recommendation, tags, service_scope, city, state, zip_code, website, recommender_message, visibility, street_address, street_address_city, street_address_state, street_address_zip_code, initial_rating, total_reviews`;

export const CSV_HEADERS_SCHEMA_FRONTEND_TEXT = `Business Name, Your Experience, Rating (1-5), Provider Contact Name (Optional), Website (Optional), Phone (Optional), Tags (comma-separated, Optional), Publish Scope (Public/Specific Trust Circles/Full Trust Circle, Optional), Trust Circle IDs (comma-separated if Specific Trust Circles, Optional)`;
